<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>


<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">Card Number Conflict - Reassign?</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
        
        @if (parkerId) {
        <p>
            This card number is already assigned to this Parker:<br />
            Name: <strong>{{parkerName}}</strong><br />
            Parker Id: <strong>{{parkerId}}</strong><br />
            Card Number: <strong>{{currentCardNumber}}</strong><br />
            Parker Status: <strong>{{activeDisplay}}</strong>
        </p>
        } @else {
        <p>
            The following Card Number, <strong>{{currentCardNumber}}</strong>, is currently assigned
            <br /> to an Amano Profile, but there is no spACE-AR Parker
            <br /> associated with this Amano Profile.
        </p>
        }
        <hr />
        <p>
           Click Yes to reassign this card number to the new Parker. <br />
           Click No to enter a different card number.
        </p>
    </div>
    
</div>
<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:40px;position:relative;">
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" >No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial style="background-color:#003087 !important;color:white !important">Yes</button>
</div>
